<template>
    <section>
        <div class="row">
            <div class="col">
                <nav aria-label="breadcrumb">
                    <ul class="breadcrumb">
                        <li class="breadcrumb-item h3 font-weight-bold mb-0">
                            <router-link v-bind:to="{ name: 'evaluation/index' }">
                                Laporan Pengajaran
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active font-weight-medium" aria-current="page">
                            List Laporan Pengajaran
                        </li>
                    </ul>
                </nav>
            </div>
        </div>

        <div class="row px-3">
            <div class="col-12">
                <form v-on:submit.prevent="paginate(1, false)">
                    <div class="row d-md-flex d-none">
                        <div class="col-2 px-1" v-if="roleElligibleView()">
                            <label class="text-muted mb-0">Filter Nama Pengajar</label>
                        </div>
                        <div class="col-2 px-1">
                            <label class="text-muted mb-0">Search</label>
                        </div>
                        <div class="col-4 px-1">
                            <label class="text-muted mb-0">Interval</label>
                        </div>
                        <div class="col-md px-1">
                            <label class="text-muted mb-0">Periode</label>
                        </div>
                    </div>
                    <div class="row mb-4 align-items-center">
                        <div class="col-md-2 col-sm-6 mt-2 px-1" v-if="roleElligibleView()">
                            <select v-model="form.teacherID" class="form-control form-control-sm">
                                <option value="">Pilih Nama Pengajar...</option>
                                <option v-for="teacher in teachers" v-bind:value="teacher.userID" v-bind:key="teacher.userID">{{ teacher.user.name }}</option>
                            </select>
                        </div>
                        <div class="col-md-2 col-sm-6 mt-2 px-1">
                            <input v-model="form.keyword" class="form-control form-control-sm" placeholder="Search..." />
                        </div>
                        <div class="col-md-2 col-sm-6 px-1 mt-2">
                            <datepicker v-model="form.start" v-bind:language="dateLanguage" full-month-name monday-first clear-button input-class="form-control form-control-sm"></datepicker>
                        </div>
                        <div class="col-md-2 col-sm-6 px-1 mt-2">
                            <datepicker v-model="form.end" v-bind:language="dateLanguage" full-month-name monday-first clear-button v-bind:disabled-dates="{to: form.start}" input-class="form-control form-control-sm"></datepicker>
                        </div>
                        <div class="col-md-2 col-sm-6 px-1 mt-2">
                            <select v-model="form.semester" class="form-control form-control-sm">
                                <option value="">Pilih Periode...</option>
                                <option v-for="semester in semesters" v-bind:value="semester.id" v-bind:key="semester.id">{{ semester.name }}</option>
                            </select>
                        </div>
                        <div class="col-lg col-auto px-1">
                            <button type="submit" class="btn btn-danger btn-sm px-3 mt-2">
                                Search
                            </button>
                        </div>
                        <div class="col-auto px-1 ml-auto">
                            <button class="btn btn-outline-danger btn-sm px-3 mt-2" v-on:click="download">
                                Download
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <div class="row">
            <div class="col-12 mb-4">
                <div id="table-primary" class="table-responsive" v-dragscroll="!isMobile()">
                    <table class="table">
                        <thead>
                            <tr class="text-danger font-weight-bold">
                                <th scope="col">
                                    Tanggal
                                </th>
                                <th scope="col">
                                    Nama Lengkap
                                </th>
                                <th scope="col">
                                    Lokasi BTA
                                </th>
                                <th scope="col">
                                    Kelas BTA
                                </th>
                                <th scope="col">
                                    Mata Pelajaran
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="shadow-sm" v-for="evaluation in evaluations" v-bind:key="evaluation.id" v-on:click="$router.push({name: 'evaluation/view', params: {id: evaluation.id}})">
                                <td>
                                    <span class="text-loading">{{ [evaluation.session.date, "YYYY-MM-DD"] | moment("dddd, D MMMM YYYY") }}</span>
                                </td>
                                <td>
                                    <span class="text-loading">{{ evaluation.session.teacher.employee.user.name }}</span>
                                </td>
                                <td>
                                    <span class="text-loading">{{ evaluation.session.branchClass.pattern.branchProgram.branch.name }}</span>
                                </td>
                                <td>
                                    <span class="text-loading">{{ evaluation.session.branchClass.name }}</span>
                                </td>
                                <td>
                                    <span class="text-loading">{{ evaluation.session.subject.name }}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-12 mb-4">
                <nav class="float-right">
                    <paginate v-model="page" next-text="<i class='fa fa-chevron-right'></i>" prev-text="<i class='fa fa-chevron-left'></i>" v-bind:click-handler="paginate" v-bind:page-count="pageCount" container-class="pagination pagination-sm flex-wrap" page-class="page-item" prev-class="page-item" v-bind:next-class="'page-item'" page-link-class="page-link" prev-link-class="page-link" next-link-class="page-link" v-bind:hide-prev-next="true">
                    </paginate>
                </nav>
            </div>
        </div>
    </section>
</template>

<script>
    import { mapState } from 'vuex';
    import { dragscroll } from 'vue-dragscroll';
    import { id } from 'vuejs-datepicker/dist/locale';
    import { semesters } from '@/params.js';
    import Paginate from 'vuejs-paginate';
    import Datepicker from 'vuejs-datepicker';
    import qs from 'qs';

    export default {
        name: "EvaluationIndex",
        directives: {dragscroll},
        components: {
            Paginate,
            Datepicker
        },
        computed: mapState([
            'profile',
            'term'
        ]),
        watch: {
            profile() {
                this.fetchData();
            },
            term() {
                this.paginate(this.page);
            }
        },
        data() {
            return {
                form: {
                    teacherID: '',
                    keyword: '',
                    start: this.$moment().toDate(),
                    end: this.$moment().toDate(),
                    semester: 1
                },
                pageCount: 0,
                page: 1,
                dateLanguage: id,
                teachers: [],
                semesters: semesters,
                evaluations: []
            };
        },
        methods: {
            paginate(page, scroll = true) {
                let interval = {
                    start: this.form.start ? this.$moment(this.form.start).format('YYYY-MM-DD') : '',
                    end: this.form.end ? this.$moment(this.form.end).format('YYYY-MM-DD') : ''
                };
                this.axios.get(process.env.API_URL + '/evaluation', {params: Object.assign({}, this.form, interval, {termID: this.term.id, page: page})}).then(response => {
                    this.evaluations = response.data.data.data;
                    this.pageCount = response.data.data.total ? response.data.data.last_page : 0;

                    if (scroll) {
                        document.getElementById('table-primary').scrollIntoView();
                        var headerElement = document.getElementsByTagName('nav');
                        if (headerElement.length) {
                            window.scrollBy(0, headerElement[0].offsetHeight * -1);
                        }
                    }
                });
            },
            fetchData() {
                if (this.roleElligibleView()) {
                    this.axios.get(process.env.API_URL + '/employee/teacher').then(response => {
                        this.teachers = response.data.data;
                    });
                }
            },
            download() {
                let token = localStorage.getItem("vue-authenticate.vueauth_token");
                let interval = {
                    start: this.form.start ? this.$moment(this.form.start).format('YYYY-MM-DD') : '',
                    end: this.form.end ? this.$moment(this.form.end).format('YYYY-MM-DD') : ''
                };
                window.location = process.env.API_URL + '/evaluation/download?' + qs.stringify(Object.assign({}, this.form, interval, {token: token, termID: this.term.id}), {encode: false});
            },
            roleElligibleView() {
                return this.profile.isAdmin || (this.profile.isEmployee && (this.profile.employee.isDirector || this.profile.employee.isManager || this.profile.employee.isMentor || this.profile.employee.isBranchStaff || this.profile.employee.isBranchHead));
            },
            isMobile() {
                return 'ontouchstart' in window || navigator.msMaxTouchPoints;
            }
        },
        created() {
            this.fetchData();
        },
        mounted() {
            this.paginate(1, false);
            document.title = 'List Laporan Pengajaran - ' + process.env.APP_NAME;
        }
    };
</script>

<style scoped>
    table.table tbody tr { cursor: pointer; }
</style>


// WEBPACK FOOTER //
// src/components/evaluation/Index.vue